import React from "react";
import { LoadioStoreFeaturedSectionLoaderTemplate } from "themes/administration/loadio/components";

class LoadioStoreFeaturedSectionLoader extends React.Component {
    render() {
        return <LoadioStoreFeaturedSectionLoaderTemplate {...this.props} />;
    }
}

export default LoadioStoreFeaturedSectionLoader;
